/**
 * Utility functions for detecting and working with citations in text
 */

/**
 * Detects citation markers in the format [n] where n is a number
 * @param {string} text - The text to search for citation markers
 * @returns {Array} Array of objects with citation information: { citationNumber, index, text }
 */
export function detectCitationMarkers(text) {
  if (!text || typeof text !== 'string') {
    return [];
  }

  // Regular expression to match citation markers [n] where n is a number
  const citationRegex = /\[(\d+)\]/g;
  const markers = [];
  let match;

  // Find all matches
  while ((match = citationRegex.exec(text)) !== null) {
    markers.push({
      citationNumber: match[1], // The captured citation number
      index: match.index, // Position in the text
      text: match[0], // The full matched text including brackets
    });
  }

  return markers;
}